import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { DbTableDefinition } from 'src/app/_services/persistence/db-persistence/db-table-definition';

@Injectable({
  providedIn: 'root',
})
export class ServicejobDbTableDefinition extends DbTableDefinition {
  tableName = 'servicejobs';
  tableStructure = `(id BIGINT(20) PRIMARY KEY null,
      label TEXT NOT NULL,
      databag LONGTEXT,
      keywordlist TEXT,
      description TEXT,
      priority INT(11),
      status INT(11),
      validpersonstring LONGTEXT,
      contactinfo VARCHAR(100),
      validphonenumber VARCHAR(50),
      validmail VARCHAR(700),
      validlatitude DOUBLE,
      validlongitude DOUBLE,
      validmatchingradius DOUBLE,
      employeeid BIGINT(20),
      employeelabel TEXT,
      equipmentid BIGINT(20),
      equipmentlabel TEXT,
      branchid BIGINT(20),
      branchlabel TEXT,
      locationid BIGINT(20),
      locationlabel TEXT,
      accountingnumber VARCHAR(50),
      name VARCHAR(255),
      projsupervisorid BIGINT(20),
      projsupervisorlabel TEXT,
      supervisorid BIGINT(20),
      supervisorlabel TEXT,
      plannedtime DOUBLE,
      additionalinfotext TEXT,
      branchname LONGTEXT,
      branchfullstreet TEXT,
      branchcity TEXT,
      createdtstamp BIGINT(20),
      geodataisaddresspreciseormanual BOOLEAN,
      pcdecity TEXT,
      fullstreet TEXT,
      appaccountingnumber VARCHAR(50),
      validcustomername TEXT,
      ispermanentjob BOOLEAN,
      tourordernumber INT, 
      tourid BIGINT(20),
      tourlabel TEXT,
      tourstopid BIGINT(20),
      tourstoplabel TEXT,
      tagtemplatevalidid BIGINT(20),
      tagtemplatevalidlabel TEXT
      );`;

  constructor() {
    super();
    // Add UpdateStatements to Map
    if (Capacitor.getPlatform() === 'web') {
      this.alterStatements.push({
        table: this.tableName,
        col: 'geodataismanual',
        type: 'BOOLEAN',
      });
      this.alterStatements.push({
        table: this.tableName,
        col: 'customerbranchid',
        type: 'BIGINT(20)',
      });
      this.alterStatements.push({
        table: this.tableName,
        col: 'customerbranchlabel',
        type: 'TEXT',
      });
      this.alterStatements.push({
        table: this.tableName,
        col: 'recipientbranchid',
        type: 'BIGINT(20)',
      });
      this.alterStatements.push({
        table: this.tableName,
        col: 'recipientbranchlabel',
        type: 'TEXT',
      });
    } else {
      this.updateStatements.set(9, [
        `ALTER TABLE ${this.tableName} ADD COLUMN geodataismanual BOOLEAN;`,
      ]);

      this.updateStatements.set(10, [
        `ALTER TABLE ${this.tableName} ADD COLUMN customerbranchid BIGINT(20);`,
        `ALTER TABLE ${this.tableName} ADD COLUMN customerbranchlabel TEXT;`,
        `ALTER TABLE ${this.tableName} ADD COLUMN recipientbranchid BIGINT(20);`,
        `ALTER TABLE ${this.tableName} ADD COLUMN recipientbranchlabel TEXT;`,
      ]);
    }
  }
}
